// extracted by mini-css-extract-plugin
export default {"header":"NW-z","logo":"OW-z","signin":"PW-z"};